import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SharedService } from 'src/app/core/services/shared.service';

@Component({
  selector: 'app-cambio-contrasena',
  templateUrl: './cambio-contrasena.component.html',
  styleUrls: ['./cambio-contrasena.component.scss']
})
export class CambioContrasenaComponent implements OnInit {
  cambioClaveForm: FormGroup;
  mensaje: string = '';
  mostrarMensaje: boolean = false;
  procesando: boolean = false;
  mostrarPassword: boolean = false;
  
  intPAD10COD: string = '';
  strPAD17NUM: string = '';
  intPAD17COD: string = '';
  
  aprobado: boolean = true;
  estado: boolean = true;
  superUsuario: boolean = false;
  serverURL	: string = "";
  
  usuarios: any[] = []; 

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private dataService: SharedService
  ) {
    this.cambioClaveForm = this.fb.group({
      usuario: [''],
      claveActual: [''],
      claveNueva: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(10)]],
      claveConfirmacion: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.intPAD10COD = params['p'] || '';
      this.strPAD17NUM = params['s'] || '';
      this.intPAD17COD = params['n'] || '';
      
      this.verificarSeguridad();
    });
  }

  verificarSeguridad(): void {
    const llaves = {
      LLAVES: [
        {
          PAD10COD: this.intPAD10COD,
          PAD17COD: this.intPAD17COD,
          PAD17NUM: this.strPAD17NUM
        }
      ]
    };

    this.dataService.ConsultarWS("api/publicos/VerificarSeguridad", JSON.stringify(llaves)).subscribe(
      (resp: any) => {

        const datos = resp?.DATA && resp.DATA.length > 0 ? resp.DATA[0] : null;

        if (!datos) {
          this.aprobado = false;
          Swal.fire({
            icon: 'error',
            title: 'Error de Seguridad',
            text: 'Respuesta inválida del servidor.',
            confirmButtonColor: '#2196F3'
          });
          return;
        }

        this.aprobado     = datos.aprobado;
        this.estado       = datos.estado;
        this.superUsuario = datos.superUsuario;
        this.serverURL = datos.serverURL;

        if (!this.estado) {
          this.cambioClaveForm.get('claveActual')?.setValidators([Validators.required]);
          this.cambioClaveForm.get('claveActual')?.updateValueAndValidity();
        }
      },
      error => {
        this.aprobado = false;
        console.error('Error al verificar seguridad:', error);

        Swal.fire({
          icon: 'error',
          title: 'Error de Seguridad',
          text: 'No se pudo verificar la seguridad de la página.',
          confirmButtonColor: '#2196F3'
        });
      }
    );
  }

  togglePasswordVisibility(): void {
    this.mostrarPassword = !this.mostrarPassword;
  }

  validarFormulario(): boolean {
    const claveNueva = this.cambioClaveForm.get('claveNueva')?.value;
    const claveConfirmacion = this.cambioClaveForm.get('claveConfirmacion')?.value;

    if (!claveNueva) {
      Swal.fire({
        icon: 'warning',
        title: 'Campo Requerido',
        text: 'Debe indicar su contraseña nueva.',
        confirmButtonColor: '#2196F3'
      });
      return false;
    }

    if (claveNueva !== claveConfirmacion) {
      Swal.fire({
        icon: 'error',
        title: 'Contraseñas no coinciden',
        text: 'La contraseña nueva no es igual a la confirmación.',
        confirmButtonColor: '#2196F3'
      });
      return false;
    }

    return true;
  }

  primeraContrasena(): void {
    if (!this.validarFormulario()) return;

    this.procesando = true;
    this.mensaje = 'Procesando... Espere por favor...';
    this.mostrarMensaje = true;

    const llaves = {
      LLAVES: [
        {
          PAD10COD: this.intPAD10COD,
          PAD17COD: this.intPAD17COD,
          PAD17NUM: this.strPAD17NUM,
          CLAVEN: this.cambioClaveForm.get('claveNueva')?.value
        }
      ]
    };

    this.dataService.ConsultarWS('api/publicos/PrimeraClave', JSON.stringify(llaves)).subscribe(
      (response: any) => {
        this.procesando = false;
        this.mostrarMensaje = false;
        this.limpiarFormulario();
        
        Swal.fire({
          icon: 'success',
          title: '¡Contraseña Establecida!',
          text: response.mensaje || 'Su contraseña ha sido establecida correctamente.',
          confirmButtonColor: '#2196F3'
        });
      },
      error => {
        this.procesando = false;
        this.mostrarMensaje = false;
  
        const backendMsg =
          error ||
          'Error al cambiar la contraseña';
  
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: backendMsg,
          confirmButtonColor: '#2196F3'
        });
      }
    );
  }

  limpiarFormulario(): void {
    this.cambioClaveForm.patchValue({
      claveActual: '',
      claveNueva: '',
      claveConfirmacion: ''
    });
  }

  regresarPrincipal(): void {
    window.location.href = this.serverURL;
  }
}
